import { FiPhone } from 'react-icons/fi';

import Input from '@components/Input';

import { FieldRendererProps } from '../types';

const PhoneField = ({ field, disabled }: FieldRendererProps) => (
  <Input
    name={field.name}
    type="tel"
    mask="phone"
    placeholder={field.placeholder || field.label}
    icon={FiPhone}
    disabled={disabled}
    required={field.is_required}
    inputMode="tel"
    autoComplete="tel"
  />
);

export default PhoneField;
